import { Button } from '@vadiun/react-components';
import { CREATE, TABLE } from 'shared/constans';
import PageContainer from 'layout/components/PageContainer';
import PageHeader from 'layout/components/PageHeader';
import React, { useRef, useState } from 'react';
import DiscountsTable from '../components/discount-table/DiscountsTable';
import { createTableScrollHandler } from 'utils/tableUtils';
import { useDiscounts } from '../hook/useDiscounts';
import DiscountCreate from '../components/DiscountCreate';
import { payLoadAddDiscount } from '../models/discountsModel';

const DiscountsPage = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [visiblePage, setVisiblePage] = useState(TABLE);
  const {
    discounts,
    totalItems,
    rowsPerPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSearchChange,
    handleSortChange,
    addDiscountMutation,
    deleteDiscount,
    filters,
    onFiltersChange,
    getAllDiscounts,
    loadingAllDiscounts,
    allDiscountsData

  } = useDiscounts();

  const discountCreate = async (values: any) => {
    const payload: payLoadAddDiscount = {
      ...values
    };
    await addDiscountMutation.mutate(payload);
    setVisiblePage(TABLE);
  };

  const remove = async (discountId: number) => {
    await deleteDiscount(discountId);
  };

  return (
    <div ref={tableRef}>
      <PageHeader
        area="Inventarios"
        title="Descuentos"
        subArea={
          visiblePage === TABLE ? 'Listado de descuentos' : 'Nuevo descuento'
        }
        toolbar={
          <>
            {visiblePage === TABLE ? (
              <Button onClick={() => setVisiblePage(CREATE)} variant="light">
                Crear Descuento
              </Button>
            ) : (
              <Button onClick={() => setVisiblePage(TABLE)} variant="light">
                Volver
              </Button>
            )}
          </>
        }
      />
      <PageContainer>
        {visiblePage === TABLE && (
          <DiscountsTable
            handlePageChange={createTableScrollHandler(tableRef)}
            discounts={discounts}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            totalItems={totalItems}
            page={page}
            rowsPerPage={rowsPerPage}
            onSearchChange={handleSearchChange}
            onSortChange={handleSortChange}
            handleDelete={remove}
            filters={filters}
            onFiltersChange={onFiltersChange}
          />
        )}

        {visiblePage === CREATE && (
          <DiscountCreate
            setVisiblePage={setVisiblePage}
            discountCreate={discountCreate}
            getAllDiscounts={getAllDiscounts}
            allDiscountsData={allDiscountsData}
            loadingAllDiscounts={loadingAllDiscounts}
          />
        )}
      </PageContainer>
    </div>
  );
};

export default DiscountsPage;
